'use es6';

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SidebarCardError() {
  return /*#__PURE__*/_jsx(Paragraph, {
    paddingInline: "500",
    paddingBlockStart: "400",
    "data-unit-test": "SidebarCardError",
    "data-test-id": "SidebarCardError",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "customerDataSidebar.sidebarCardError_jsx",
      options: {
        href: window.location.href
      },
      elements: {
        Link
      }
    })
  });
}